export default "__VITE_ASSET__v5H1S5_a__"